import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {MvsCrudService} from "features/core/shared/service/crud/mvs-crud.service";
import {HelpArticleDto} from "../../model/dto/help-article.dto";
import {HelpSuggestedQuestionDto} from "../../model/dto/help-context.dto";

@Injectable({
    providedIn: 'root'
})
export class HelpContextService {

    private readonly apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = MvsCrudService.baseUrl + '/cb/help/context';
    }

    getContextualArticles(route: string, moduleAlias: string): Observable<HelpArticleDto[]> {
        const params = new HttpParams()
            .set('route', route)
            .set('moduleAlias', moduleAlias);
        return this.http.get<HelpArticleDto[]>(`${this.apiUrl}/articles`, {params});
    }

    getSuggestedQuestions(moduleAlias: string, route?: string): Observable<HelpSuggestedQuestionDto[]> {
        let params = new HttpParams().set('moduleAlias', moduleAlias);
        if (route) {
            params = params.set('route', route);
        }
        return this.http.get<HelpSuggestedQuestionDto[]>(`${this.apiUrl}/questions`, {params});
    }
}
